import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function useExpenseDetailDrawer() {
  const [opts, set] = useQueryStates({
    expense: parseAsString,
  });

  return {
    opened: !!opts.expense,
    open: (id: string, type?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set(
        { expense: id },
        {
          history: type || 'push',
        }
      );
    },
    close: () => set(null),
    expenseId: opts.expense,
  };
}
